import React from "react";
import { object, func, bool, string } from "prop-types";

import { connect } from "react-redux";

import {
  onboardUpdateState,
  updateUserInProfileSilent,
} from "../redux/actions";

import ImageInput from "../components/BasicInfo/ImageInput";

import history from "../history";

const ProfileImageUpload = ({
  appData,
  loading,
  updateProfile,
  description,
  showHeader = true,
  imageFileKey = "profileImageData",
  redirectAfterSave = true,
  text,
  isDnata,
  isABM,
  isUploaded = false,
  allowPdf = false,
  handleChange = null,
}) => {
  const saveProfileImage = (profileImageData) => {
    const { candidateRef, emailAddress, permissions } = appData;
    const updatedUserData = {
      candidateRef,
      emailAddress,
      [imageFileKey]: profileImageData,
      isPecan: permissions.isPecan,
    };
    const promises = [updateProfile(candidateRef, updatedUserData)];
    if (redirectAfterSave) {
      promises.push(history.push("/profile"));
    }

    Promise.all(promises);
  };

  const onImageload = (imageEvent) => {
    const image = imageEvent.target;
    // Resize the image
    const canvas = document.createElement("canvas");
    const maxSize = 1000;
    let { width, height } = image;
    if (width > height) {
      if (width > maxSize) {
        height *= maxSize / width;
        width = maxSize;
      }
    } else if (height > maxSize) {
      width *= maxSize / height;
      height = maxSize;
    }
    canvas.width = width;
    canvas.height = height;
    canvas.getContext("2d").drawImage(image, 0, 0, width, height);
    const dataUrl = canvas.toDataURL("image/jpeg");
    const base64Marker = ";base64,";
    const resizedImageData = dataUrl.split(base64Marker)[1];
    return saveProfileImage(resizedImageData);
  };

  const onReaderLoad = (readerEvent) => {
    const image = new Image();
    image.onload = onImageload;
    image.src = readerEvent.target.result;
    return image;
  };

  const defaultHandleChange = (event) => {
    // Read in file
    const file = event.target.files[0];
    const reader = new FileReader();

    // Ensure it's an image
    if (file.type.match(/image.*/)) {
      // Load the image
      reader.onload = onReaderLoad;
      reader.readAsDataURL(file);
    }
    return reader;
  };

  return (
    <ImageInput
      imageKey={imageFileKey}
      handleChange={handleChange || defaultHandleChange}
      loading={loading}
      description={description}
      title="Upload your profile image"
      showHeader={showHeader}
      text={text}
      isDnata={isDnata}
      isABM={isABM}
      isUploaded={isUploaded}
      allowPdf={allowPdf}
    />
  );
};

ProfileImageUpload.propTypes = {
  appData: object,
  loading: bool,
  description: string.isRequired,
  updateProfile: func,
  showHeader: bool,
  imageFileKey: string,
  redirectAfterSave: bool,
  text: string,
  isDnata: bool,
  isABM: bool,
  isUploaded: bool,
  allowPdf: bool,
  handleChange: func,
};

const mapStateToProps = (state) => ({
  appData: state.core.app,
  description: state.core.umbracoContent.profileImageSub,
  loading: state.core.loading,
});

const mapDispatchToProps = {
  onboardUpdateState,
  updateProfile: updateUserInProfileSilent,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(ProfileImageUpload);
